'use client';

import { c as _c } from "react/compiler-runtime";
import { Info } from 'lucide-react';
import { useMediaQuery } from 'usehooks-ts';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { EDITOR_CHOICE_DESCRIPTION_MAX_LENGTH } from '@/constants/worlds-landing';
import { truncateDescription } from '@/lib/world-card';
const CONTENT_CLASS_NAME = 'bg-vive-popup/90 text-vive-primary-20 caption max-w-80 rounded-[3px] border-0 px-3 py-4 shadow-md backdrop-blur-xl';
type EditorChoiceDescriptionProps = {
  description?: string | null;
};
export default function EditorChoiceDescription(t0) {
  const $ = _c(21);
  const {
    description
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultValue: true,
      initializeWithValue: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const supportsHover = useMediaQuery("(hover: hover) and (pointer: fine)", t1);
  let full;
  let t2;
  let t3;
  if ($[1] !== description) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      full = description?.trim();
      if (!full) {
        t3 = null;
        break bb0;
      }
      t2 = truncateDescription(full, EDITOR_CHOICE_DESCRIPTION_MAX_LENGTH);
    }
    $[1] = description;
    $[2] = full;
    $[3] = t2;
    $[4] = t3;
  } else {
    full = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  const {
    text,
    isTruncated
  } = t2;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Info className="stroke-vive-primary-30 relative size-4 transition-colors group-hover:stroke-white group-data-[state=open]:stroke-white" aria-hidden={true} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== full) {
    t5 = <button type="button" aria-label={full} className="group before:bg-vive-primary-40/50 relative ml-1 inline-flex cursor-pointer align-text-bottom before:absolute before:-inset-1.5 before:rounded-full before:opacity-0 before:backdrop-blur-2xl before:transition-opacity hover:before:opacity-100 data-[state=open]:before:opacity-100">{t4}</button>;
    $[6] = full;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const infoButton = t5;
  let t6;
  if ($[8] !== full) {
    t6 = <span className="sr-only">{full}</span>;
    $[8] = full;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== text) {
    t7 = <span aria-hidden={true} className="text-vive-primary-30">{text}</span>;
    $[10] = text;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== full || $[13] !== infoButton || $[14] !== isTruncated || $[15] !== supportsHover) {
    t8 = isTruncated && <span className="whitespace-nowrap"><span aria-hidden={true} className="text-vive-primary-30">…</span>{supportsHover ? <Tooltip><TooltipTrigger asChild={true}>{infoButton}</TooltipTrigger><TooltipContent side="bottom" align="center" sideOffset={32} className={CONTENT_CLASS_NAME}>{full}</TooltipContent></Tooltip> : <Popover><PopoverTrigger asChild={true}>{infoButton}</PopoverTrigger><PopoverContent side="bottom" align="center" sideOffset={32} collisionPadding={8} className={CONTENT_CLASS_NAME}>{full}</PopoverContent></Popover>}</span>;
    $[12] = full;
    $[13] = infoButton;
    $[14] = isTruncated;
    $[15] = supportsHover;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = <p className="caption">{t6}{t7}{t8}</p>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}